// Nutrient database (per 100g)
export const NUTRIENT_DB = {
  "prawns":          { calories:99,  protein:24,  carbs:0,   fat:0.3, fiber:0   },
  "shrimp":          { calories:99,  protein:24,  carbs:0,   fat:0.3, fiber:0   },
  "soy mince":       { calories:140, protein:18,  carbs:12,  fat:0.8, fiber:6   }, // cooked values (per 100g cooked)
  "soy mince dry":   { calories:330, protein:50,  carbs:30,  fat:2,   fiber:15  }, // dry / unhydrated
  "tvp":             { calories:330, protein:50,  carbs:30,  fat:2,   fiber:15  }, // dry
  "chicken breast":  { calories:165, protein:31,  carbs:0,   fat:3.6, fiber:0   },
  "chicken":         { calories:221, protein:26.8,carbs:0,   fat:12.6,fiber:0   },
  "beef mince":      { calories:215, protein:26,  carbs:0,   fat:12,  fiber:0   },
  "beef":            { calories:192, protein:30.9,carbs:0,   fat:7.5, fiber:0   },
  "tuna":            { calories:116, protein:26,  carbs:0,   fat:1,   fiber:0   },
  "salmon":          { calories:208, protein:20,  carbs:0,   fat:13,  fiber:0   },
  "fish":            { calories:120, protein:23,  carbs:0,   fat:2,   fiber:0   },
  "eggs":            { calories:147, protein:12.6,carbs:0.6, fat:10.3,fiber:0   },
  "egg":             { calories:147, protein:12.6,carbs:0.6, fat:10.3,fiber:0   },
  "tofu":            { calories:76,  protein:8,   carbs:2,   fat:4,   fiber:0.3 },
  "lentils":         { calories:352, protein:24.6,carbs:63,  fat:1,   fiber:10.7,_cupGrams:192 },
  "cottage cheese":  { calories:80,  protein:12,  carbs:3,   fat:1.5, fiber:0,   _cupGrams:226 },
  "rice":            { calories:365, protein:7,   carbs:80,  fat:0.7, fiber:1.3, _cupGrams:185 },
  "dry rice":        { calories:365, protein:7,   carbs:80,  fat:0.7, fiber:1.3, _cupGrams:185 },
  "white rice dry":  { calories:365, protein:7,   carbs:80,  fat:0.7, fiber:1.3, _cupGrams:185 },
  "brown rice":      { calories:365, protein:7,   carbs:80,  fat:0.7, fiber:1.3, _cupGrams:185 },
  "cooked rice":     { calories:130, protein:2.7, carbs:28,  fat:0.3, fiber:0.4, _cupGrams:158 },
  "white rice cooked":{ calories:130, protein:2.7, carbs:28, fat:0.3, fiber:0.4, _cupGrams:158 },
  "cooked brown rice":{ calories:123, protein:2.7, carbs:25.6,fat:1,   fiber:1.8, _cupGrams:195 },
  "oats":            { calories:383, protein:13.1,carbs:57,  fat:7.9, fiber:11.6,_cupGrams:80  },
  "rolled oats":     { calories:383, protein:13.1,carbs:57,  fat:7.9, fiber:11.6,_cupGrams:80  },
  "rolled oat":      { calories:383, protein:13.1,carbs:57,  fat:7.9, fiber:11.6,_cupGrams:80  },
  "pasta":           { calories:360, protein:11.5,carbs:73.6,fat:1.5, fiber:3.2, _cupGrams:100 },
  "cooked pasta":    { calories:158, protein:6,   carbs:31,  fat:1,   fiber:1.8, _cupGrams:140 },
  "bread":           { calories:235, protein:8.5, carbs:44,  fat:1.7, fiber:4   },
  "brown bread":     { calories:227, protein:7.9, carbs:41,  fat:1.3, fiber:5.5 },
  "sourdough":       { calories:222, protein:8.6, carbs:38.9,fat:2.6, fiber:3.7 },
  "sourdough bread": { calories:222, protein:8.6, carbs:38.9,fat:2.6, fiber:3.7 },
  "wholewheat bread":{ calories:221, protein:8.4, carbs:39,  fat:2.1, fiber:5.1 },
  "sweet potato":    { calories:86,  protein:1.6, carbs:20,  fat:0.1, fiber:3   },
  "potato":          { calories:77,  protein:2,   carbs:17,  fat:0.1, fiber:2.2 },
  "quinoa":          { calories:120, protein:4.4, carbs:22,  fat:1.9, fiber:2.8, _cupGrams:170 },
  "broccoli":        { calories:34,  protein:2.8, carbs:7,   fat:0.4, fiber:2.6 },
  "spinach":         { calories:23,  protein:2.9, carbs:3.6, fat:0.4, fiber:2.2, _cupGrams:30  },
  "kale":            { calories:49,  protein:4.3, carbs:9,   fat:0.9, fiber:3.6 },
  "carrot":          { calories:41,  protein:0.9, carbs:10,  fat:0.2, fiber:2.8 },
  "onion":           { calories:40,  protein:1.1, carbs:9,   fat:0.1, fiber:1.7 },
  "avocado":         { calories:160, protein:2,   carbs:9,   fat:15,  fiber:6.7 },
  "olive oil":       { calories:884, protein:0,   carbs:0,   fat:100, fiber:0   },
  "peanut butter":   { calories:588, protein:25,  carbs:20,  fat:50,  fiber:6,   _cupGrams:258 },
  "peanuts":         { calories:567, protein:26,  carbs:16,  fat:49,  fiber:8.5, _cupGrams:146 },
  "almonds":         { calories:579, protein:21,  carbs:22,  fat:50,  fiber:12.5,_cupGrams:143 },
  "milk":            { calories:61,  protein:3.2, carbs:4.8, fat:3.3, fiber:0,   _cupGrams:240 },
  "greek yogurt":    { calories:57,  protein:7.7, carbs:5,   fat:0.5, fiber:0,   _cupGrams:245 },
  "cheese":          { calories:402, protein:25,  carbs:1.3, fat:33,  fiber:0   },
  "banana":          { calories:89,  protein:1.1, carbs:23,  fat:0.3, fiber:2.6, _cupGrams:150 },
  "apple":           { calories:52,  protein:0.3, carbs:14,  fat:0.2, fiber:2.4, _cupGrams:125 },
  "butter":          { calories:717, protein:0.9, carbs:0.1, fat:81,  fiber:0   },
  "pea protein":     { calories:375, protein:75,  carbs:6,   fat:8,   fiber:3,   _cupGrams:100 },
  "whey protein":    { calories:370, protein:80,  carbs:7,   fat:4,   fiber:0,   _cupGrams:120 },
  "protein powder":  { calories:370, protein:75,  carbs:8,   fat:4,   fiber:0,   _cupGrams:120 },
  "protein shake":   { calories:120, protein:25,  carbs:5,   fat:2,   fiber:1   },
  "casein":          { calories:360, protein:80,  carbs:4,   fat:2,   fiber:0,   _cupGrams:110 },
  "frozen berries":  { calories:50,  protein:0.7, carbs:12,  fat:0.2, fiber:2.4, _cupGrams:140 },
  "blueberries":     { calories:57,  protein:0.7, carbs:14,  fat:0.3, fiber:2.4, _cupGrams:148 },
  "strawberries":    { calories:32,  protein:0.7, carbs:8,   fat:0.3, fiber:2,   _cupGrams:152 },
  "raspberries":     { calories:52,  protein:1.2, carbs:12,  fat:0.7, fiber:6.5, _cupGrams:123 },
  "mixed berries":   { calories:50,  protein:1,   carbs:12,  fat:0.3, fiber:2.5, _cupGrams:140 },
  "orange":          { calories:47,  protein:0.9, carbs:12,  fat:0.1, fiber:2.4 },
  "mango":           { calories:60,  protein:0.8, carbs:15,  fat:0.4, fiber:1.6 },
  "pineapple":       { calories:50,  protein:0.5, carbs:13,  fat:0.1, fiber:1.4, _cupGrams:165 },
  "nectarine":       { calories:44,  protein:1,   carbs:11,  fat:0.3, fiber:1.7 },
  "nectarines":      { calories:44,  protein:1,   carbs:11,  fat:0.3, fiber:1.7 },
  "grapes":          { calories:69,  protein:0.7, carbs:18,  fat:0.2, fiber:0.9 },
  "dates":           { calories:277, protein:1.8, carbs:75,  fat:0.2, fiber:6.7 },
  "raisins":         { calories:299, protein:3.1, carbs:79,  fat:0.5, fiber:3.7 },
  "water":           { calories:0,   protein:0,   carbs:0,   fat:0,   fiber:0   },
  "coconut water":   { calories:19,  protein:0.7, carbs:4,   fat:0.2, fiber:1.1 },
  "orange juice":    { calories:45,  protein:0.7, carbs:10,  fat:0.2, fiber:0.2 },
  "almond milk":     { calories:13,  protein:0.4, carbs:0.7, fat:1.1, fiber:0.2, _cupGrams:240 },
  "oat milk":        { calories:46,  protein:1,   carbs:7,   fat:1.5, fiber:0.5, _cupGrams:240 },
  "soy milk":        { calories:54,  protein:3.3, carbs:6,   fat:1.8, fiber:0.4, _cupGrams:240 },
  "walnuts":         { calories:654, protein:15,  carbs:14,  fat:65,  fiber:6.7, _cupGrams:100 },
  "cashews":         { calories:553, protein:18,  carbs:30,  fat:44,  fiber:3.3, _cupGrams:137 },
  "sunflower seeds": { calories:584, protein:21,  carbs:20,  fat:51,  fiber:8.6, _cupGrams:140 },
  "chia seeds":      { calories:486, protein:17,  carbs:42,  fat:31,  fiber:34,  _cupGrams:160 },
  "flaxseed":        { calories:534, protein:18,  carbs:29,  fat:42,  fiber:27,  _cupGrams:168 },
  "hemp seeds":      { calories:553, protein:32,  carbs:9,   fat:49,  fiber:4,   _cupGrams:160 },
  "honey":           { calories:304, protein:0.3, carbs:82,  fat:0,   fiber:0.2, _cupGrams:340 },
  "jam":             { calories:250, protein:0.4, carbs:65,  fat:0.1, fiber:1,   _cupGrams:320 },
  "dark chocolate":  { calories:546, protein:5,   carbs:60,  fat:31,  fiber:7   },
  "cocoa powder":    { calories:228, protein:20,  carbs:58,  fat:14,  fiber:33,  _cupGrams:86  },
  "protein bar":     { calories:380, protein:25,  carbs:40,  fat:12,  fiber:3   },
  "clicks advanced protein bar": { calories:139, protein:10, carbs:20.9, fat:13.9, fiber:1.6, _serving:1 },
  "granola":         { calories:471, protein:10,  carbs:64,  fat:20,  fiber:5,   _cupGrams:120 },
  "hummus":          { calories:166, protein:8,   carbs:14,  fat:10,  fiber:6,   _cupGrams:246 },
  "cream cheese":    { calories:342, protein:6,   carbs:4,   fat:34,  fiber:0,   _cupGrams:232 },
  "sour cream":      { calories:198, protein:2.4, carbs:4.6, fat:19,  fiber:0,   _cupGrams:240 },
  "turkey":          { calories:189, protein:29,  carbs:0,   fat:7,   fiber:0   },
  "tilapia":         { calories:96,  protein:20,  carbs:0,   fat:2,   fiber:0   },
  "sardines":        { calories:208, protein:25,  carbs:0,   fat:11,  fiber:0   },
  "pork":            { calories:242, protein:27,  carbs:0,   fat:14,  fiber:0   },
  "lamb":            { calories:280, protein:23.5,carbs:0,   fat:20.9,fiber:0   },
  "tomato":          { calories:18,  protein:0.9, carbs:3.9, fat:0.2, fiber:1.2 },
  "cucumber":        { calories:15,  protein:0.7, carbs:3.6, fat:0.1, fiber:0.5 },
  "lettuce":         { calories:15,  protein:1.4, carbs:2.9, fat:0.2, fiber:1.3 },
  "cabbage":         { calories:25,  protein:1.3, carbs:6,   fat:0.1, fiber:2.5 },
  "zucchini":        { calories:17,  protein:1.2, carbs:3.1, fat:0.3, fiber:1   },
  "cauliflower":     { calories:25,  protein:2,   carbs:5,   fat:0.3, fiber:2   },
  "mushroom":        { calories:22,  protein:3.1, carbs:3.3, fat:0.3, fiber:1   },
  "bell pepper":     { calories:31,  protein:1,   carbs:6,   fat:0.3, fiber:2.1 },
  "celery":          { calories:16,  protein:0.7, carbs:3,   fat:0.2, fiber:1.6 },
  "beetroot":        { calories:43,  protein:1.6, carbs:10,  fat:0.2, fiber:2.8 },
  "corn":            { calories:86,  protein:3.2, carbs:19,  fat:1.2, fiber:2   },
  "edamame":         { calories:121, protein:11,  carbs:9,   fat:5,   fiber:5.2 },
  "chickpeas":       { calories:364, protein:19.3,carbs:43,  fat:6,   fiber:17.4,_cupGrams:164 },
  "chickpea":        { calories:364, protein:19.3,carbs:43,  fat:6,   fiber:17.4,_cupGrams:164 },
  "cooked chickpeas":{ calories:132, protein:8.9, carbs:20.8,fat:2.6, fiber:7.6, _cupGrams:164 },
  "beans":           { calories:111, protein:7.1, carbs:19.5,fat:0.5, fiber:5,   _cupGrams:177 },
  "kidney beans":    { calories:111, protein:7.1, carbs:19.5,fat:0.5, fiber:5,   _cupGrams:177 },
  "black beans":     { calories:132, protein:8.9, carbs:24,  fat:0.5, fiber:8.7, _cupGrams:172 },
  "lentil wraps":    { calories:116, protein:9,   carbs:20,  fat:0.4, fiber:7.9 },
  "cooked lentils":  { calories:116, protein:9,   carbs:20,  fat:0.4, fiber:7.9, _cupGrams:190 },
  "mixed veg":       { calories:49,  protein:1.8, carbs:6,   fat:0.6, fiber:5.1 },
  "mixed vegetables":{ calories:49,  protein:1.8, carbs:6,   fat:0.6, fiber:5.1 },
  "tomato puree":    { calories:82,  protein:4,   carbs:16,  fat:0.5, fiber:2   },
  "tomato paste":    { calories:82,  protein:4,   carbs:16,  fat:0.5, fiber:2   },
  "soy sauce":       { calories:50,  protein:1,   carbs:8,   fat:0,   fiber:0   },
  "green pepper":    { calories:20,  protein:0.9, carbs:4.6, fat:0.2, fiber:1.7 },
  "sugar":           { calories:387, protein:0,   carbs:100, fat:0,   fiber:0,   _cupGrams:200 },
  "maca powder":     { calories:325, protein:14,  carbs:71,  fat:3.6, fiber:7,   _cupGrams:120 },
  "macadamia milk":  { calories:18,  protein:0.2, carbs:1,   fat:1.5, fiber:0   },
  "spices":          { calories:0,   protein:0,   carbs:0,   fat:0,   fiber:0   },
  "salt":            { calories:0,   protein:0,   carbs:0,   fat:0,   fiber:0   },
  "paprika":         { calories:0,   protein:0,   carbs:0,   fat:0,   fiber:0   },
  "chilli":          { calories:282, protein:13,  carbs:50,  fat:14,  fiber:35  },
  "garlic powder":   { calories:331, protein:16.6,carbs:72.7,fat:0.7, fiber:9   },
  "sweetener":       { calories:0,   protein:0,   carbs:0,   fat:0,   fiber:0   },
};

/** Returns local DB matches for a query, formatted like API results */
export function searchLocal(query) {
  if (!query || query.trim().length < 2) return [];
  const lower = query.toLowerCase().trim();
  const results = [];
  const seen = new Set();
  const add = (key, nutrients, source) => {
    if (!seen.has(key)) {
      seen.add(key);
      results.push({ name: key, ...nutrients, source: source || "Local", per: nutrients._serving !== undefined ? "per serving" : "per 100g" });
    }
  };
  // Custom imported foods first (user's own data takes priority)
  try {
    const custom = JSON.parse(localStorage.getItem("fitlog_custom_foods") || "[]");
    for (const f of custom) {
      const k = f.name.toLowerCase();
      if (k === lower || k.includes(lower) || lower.includes(k)) {
        add(f.name, { calories: f.calories, protein: f.protein, carbs: f.carbs, fat: f.fat, fiber: f.fiber }, "My Foods");
      }
    }
  } catch {}
  // Built-in DB
  if (NUTRIENT_DB[lower]) add(lower, NUTRIENT_DB[lower]);
  for (const key of Object.keys(NUTRIENT_DB)) if (key.includes(lower)) add(key, NUTRIENT_DB[key]);
  for (const key of Object.keys(NUTRIENT_DB).sort((a, b) => b.length - a.length)) {
    if (lower.includes(key) && key.length > 3) add(key, NUTRIENT_DB[key]);
  }
  const words = lower.split(/\s+/).filter(w => w.length > 3);
  for (const key of Object.keys(NUTRIENT_DB)) {
    if (words.some(w => key.includes(w))) add(key, NUTRIENT_DB[key]);
  }
  return results.slice(0, 8);
}

export function lookupNutrients(name) {
  const lower = (name || "").toLowerCase().trim();
  if (!lower) return null;
  // Check imported/custom food cache first.
  try {
    const cache = JSON.parse(localStorage.getItem("fitlog_food_cache") || "{}");
    if (cache[lower]) return { ...cache[lower], matched: lower };
  } catch {}
  if (NUTRIENT_DB[lower]) return { ...NUTRIENT_DB[lower], matched: lower };
  for (const key of Object.keys(NUTRIENT_DB).sort((a, b) => b.length - a.length)) {
    if (lower.includes(key)) return { ...NUTRIENT_DB[key], matched: key };
  }
  for (const key of Object.keys(NUTRIENT_DB)) {
    if (key.includes(lower)) return { ...NUTRIENT_DB[key], matched: key };
  }
  const inputWords = lower.split(/\s+/).filter(w => w.length > 3);
  for (const key of Object.keys(NUTRIENT_DB)) {
    const keyWords = key.split(/\s+/);
    if (inputWords.some(w => keyWords.some(kw => kw.includes(w) || w.includes(kw)))) {
      return { ...NUTRIENT_DB[key], matched: key };
    }
  }
  return null;
}
